<template>
	<div class="d-flex align-center">
		<div class="d-flex align-center">
			<base-input
				class="ma-2"
				outlined
				dense
				type="number"
				:disabled="loading"
				label="Стар"
				:errors="localErros.old_rate || null"
				@input="$set(row, field, otherValue($event));$emit('input', $event)"
				v-model="old_rate"/>
			%
		</div>
		<v-divider vertical class="mx-10"/>
		<div class="d-flex align-center">
			<edit-input-wrapper :name="field">
				<base-input
					class="ma-2"
					outlined
					dense
					type="number"
					:errors="localErros.new_rate || null"
					:disabled="loading"
					label="Нов"
					v-model="new_rate"
					@input="$set(row, field, $event);$emit('input', $event)"
				/>
			</edit-input-wrapper>
			%
		</div>
	</div>
</template>

<script>


import BaseInput from "@/ittijs/Inputs/BaseInput.vue";
import EditInputWrapper from "@/ittijs/Inputs/EditInputWrapper.vue";

export default {
	components: {
		EditInputWrapper,
		BaseInput,
	},
	props: [
		'loading',
		'field',
		'row',
	],
	data() {
		return {
			is_value: false,
			new_rate: this.row[this.field] ? parseInt(this.row[this.field]) : 0,
			old_rate: this.otherValue(this.row[this.field] ? parseInt(this.row[this.field]) : 0),
			localErros: {},
		}
	},
	watch: {
		new_rate(newValue) {
			this.handleUpdate(newValue, 'new_rate');
		},
		old_rate(newValue) {
			this.handleUpdate(newValue, 'old_rate');
		},
		row: {
			deep: true,
			handler(newValue, oldValue) {
				if (newValue && oldValue && newValue[this.field] === oldValue[this.field]) {
					return;
				}
				this.new_rate = newValue[this.field] ? parseInt(newValue[this.field]) : 0;
			},
		},
	},
	methods: {
		isValidRate(value) {
			if(typeof value !== 'number'){
				value = parseInt(value);
			}
			return value >= 0 && value <= 100;
		},
		handleUpdate(newValue, field){
			if (!newValue)
				return;
			if (!this.isValidRate(newValue)) {
				this.localErros.field = ['Стойността трябва да е между 0 и 100'];
				return;
			}
			this[field === 'new_rate' ? 'old_rate' : 'new_rate'] = this.otherValue(newValue);
		},
		otherValue(value){
			return 100 - value;
		},
	}

}
</script>